class MainSearch extends SearchForm {
  // Keep `main-search` as a dedicated custom element while
  // relying on base `search-form` behavior only.
}

customElements.define('main-search', MainSearch);
